import { SessionConfig } from '../app/models/session-config.interface';

export const environment = {
  production: true,
  landingUrl: 'https://staging.stratocyte.com',
  cdnUrl: 'https://cdn.staging.stratocyte.com',
  assets:'./assets/',
  documentBaseUrl: '/api/user/files/',
  features: {
    paymentsEnabled: true,
    stripeEnabled: true,
    specialtyIntakeEnabled: false,
    theme: 'default',
  },
  session: {
    enabled: false,
    idleTimeoutMinutes: 120,
    absoluteTimeoutHours: 12,
    rememberMeTimeoutDays: 30,
    warningBeforeTimeoutMinutes: 2
  } as SessionConfig,
  stripe: {
    publishableKey: 'pk_test_51K5CehGXNBKx0TClPUTiqDI0sTlkGuFePqZcx0LQwm2j35Ki7bipQF1ijtZ68mwpzVAQnrD98wjkJusKxDqE4Pdn00Rvb6OMLM',
  },
  pusher: {
    key: '',
    cluster: 'mt1',
    authEndpoint: '/api/specialist/chat/pusher/auth'
  },
  zoom: {
    sdkKey: 'VnSX_6i7R3W5P4b4ei46nQ'
  }
};
